"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ng2_filter_pipe_1 = require("./ng2-filter.pipe");
var Ng2SearchPipeModule = (function () {
    function Ng2SearchPipeModule() {
    }
    return Ng2SearchPipeModule;
}());
Ng2SearchPipeModule = __decorate([
    core_1.NgModule({
        declarations: [ng2_filter_pipe_1.Ng2SearchPipe],
        exports: [ng2_filter_pipe_1.Ng2SearchPipe]
    })
], Ng2SearchPipeModule);
exports.Ng2SearchPipeModule = Ng2SearchPipeModule;
//# sourceMappingURL=ng2-filter.module.js.map


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/ng2-search-filter/dist/src/ng2-filter.module.js
// module id = ../../../../ng2-search-filter/dist/src/ng2-filter.module.js
// module chunks = 5